import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import PropTypes from 'prop-types';
import { Controller, useController, useFormContext } from 'react-hook-form';


FormCheckboxField.propTypes = {
    fieldName: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.string,
};

export default function FormCheckboxField({ fieldName, disabled = false, label }) {
    const { control } = useFormContext();
    const { field } = useController({ name: fieldName, control });

    return (
        <Controller
            name={fieldName}
            control={control}
            render={() =>
                <FormControlLabel
                    control={
                        <Checkbox
                            sx={{
                                ml: '5px', p: '4px',
                                '& .MuiSvgIcon-root': { fontSize: 14, }
                            }}
                            size='small'
                            disabled={disabled}
                            checked={!!field?.value}
                            onChange={(value) => field.onChange(value)}
                        />
                    }
                    label={
                        <Typography variant="caption" color="text.secondary">
                            {label}
                        </Typography>
                    }
                />
            }
        />
    );
}
